module.exports = __webpack_public_path__ + "img/fourth-for-good.d30431f4.png";